import React, { Component, createRef } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { closeDrawer, closeNitrum } from "../store/navSlice";

import "./Header.scss";
import sunriseLogo from "../assets/images/sunrise-medical-logo-color.svg";
import nitrumLogo from "../assets/images/nitrum-logo.svg";
import { ReactComponent as IconCaret } from "../assets/images/caret.svg";


function mapState(state) {
  const { activePart, nitrumOpen } = state.nav;
  const configCode = state.config._code;

  return {
    activePart,
    nitrumOpen,
    configCode
  };
}

const mapDispatch = { closeDrawer, closeNitrum };

class Header extends Component {
  constructor(props) {
    super();
    this.state = {
      activePartDelayed: props.activePart,
      nitrumOpenDelayed: props.nitrumOpen,
      showCopiedFeedback: false
    };

    this.copyInput = createRef();
  }

  componentDidUpdate(prevProps) {
    const part = this.props.activePart;
    const prevPart = prevProps.activePart;

    // Delay unsetting the part so out transition can play
    if (prevPart !== null && part === null) {
      clearInterval(this.timerID);
      this.timerID = setTimeout(() => {
        this.setState({
          activePartDelayed: part,
        });
      }, 500);
    } else if (prevPart !== part) {
      this.setState({
        activePartDelayed: part,
      });
    }

    const nitrumOpen = this.props.nitrumOpen;
    const prevNitrumOpen = prevProps.nitrumOpen;

    // Delay unsetting yourNitrumVisible so out transition can play
    if (prevNitrumOpen && !nitrumOpen) {
      clearInterval(this.timerID);
      this.timerID = setTimeout(() => {
        this.setState({
          nitrumOpenDelayed: false
        });
      }, 500);
    } else if (prevNitrumOpen !== nitrumOpen) {
      this.setState({
        nitrumOpenDelayed: nitrumOpen
      });
    }
  }

  render() {
    const { t, activePart, nitrumOpen } = this.props;
    const { activePartDelayed, nitrumOpenDelayed } = this.state;

    const showTitle = nitrumOpen || activePart !== null;
    let title = "";

    if (nitrumOpenDelayed) {
      title = ""; // t(`common:your_nitrum_configuration`);
    } else {
      title = t(`parts:${activePartDelayed}._part_name`);
    }

    return (
      <header className="app-header">
        <div
          className={`model ${showTitle ? "show-back" : ""}`}
          onClick={() => {
            this.props.closeDrawer();
            this.props.closeNitrum();
          }}
        >
          <div className="back">
            <IconCaret />
          </div>
          <div className="nitrum-logo">
            <img src={nitrumLogo} alt="Sunrise Medical" />
          </div>
        </div>
        <div className={`title ${showTitle ? "show" : ""}`}>{title}</div>
        <div className="logo">
          <img src={sunriseLogo} alt="Sunrise Medical" />
        </div>
      </header>
    );
  }
}

export default withTranslation(["common", "parts"])(
  connect(mapState, mapDispatch)(Header)
);
